/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryResourceType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryResourceType");
    }

    getFixupPrototypeFunction() { return ResourceQueryResourceType.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryResourceType>): ResourceQueryResourceType {
        let obj = Object.assign(new ResourceQueryResourceType(), model);
        ResourceQueryResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryResourceType>): ResourceQueryResourceType {
        if (!model) return null;
        return ResourceQueryResourceType.newInstance(<ResourceQueryResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryResourceType) {
        if (!obj) return;

        models.ResourceQueryResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryResourceType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Type for the resources
     */
    resource_types: Array<string>;

}
